/// Onde o card arrastado vai cair; fora do dnd-kit para a conta ser testável sem navegador.
export interface DropTarget {
    /// Posição na coluna de destino sem o card arrastado: o que `arrayMove` e o backend esperam.
    index: number;
    /// Card que ficará logo abaixo (`null` no fim); a prévia se ancora nele, mesmo com filtro.
    before: string | null;
}

interface Params {
    /// Ids da coluna de destino, na ordem, incluindo os escondidos por filtro.
    columnLeads: string[];
    dragged: string;
    /// Card sob o ponteiro; `null` quando o ponteiro está na coluna, fora de qualquer card.
    overId: string | null;
    /// O ponteiro passou da metade do card; sem isso, mirar o rodapé do último jogava o lead acima.
    afterTarget: boolean;
}

export const calculateDropTarget = ({
    columnLeads,
    dragged,
    overId,
    afterTarget,
}: Params): DropTarget => {
    const list = columnLeads.filter((id) => id !== dragged);

    const end: DropTarget = { index: list.length, before: null };

    if (overId === null || overId === dragged) return end;

    const position = list.indexOf(overId);

    if (position === -1) return end;

    const index = afterTarget ? position + 1 : position;

    return { index, before: list[index] ?? null };
};

/// Compara com o meio de cada card, o que permite alturas diferentes na coluna.
export const pastMidpoint = (pointerY: number, top: number, height: number) =>
    pointerY > top + height / 2;
